import type { AnalyticsTransactionRow } from './analytics-transactions.boundary';
import { getTransactionReference } from '@peanuds/shared';

const getTransactionIdentity = (transaction: AnalyticsTransactionRow) => {
  const baseId =
    transaction.id ||
    transaction.transactionId ||
    `${transaction.dateAndTime}-${getTransactionReference(transaction)}-${transaction.amount}`;

  return `${transaction.direction}:${baseId}`;
};

const getSortableTimestamp = (transactionDate: string) => {
  const parsedDate = Date.parse(transactionDate);
  return Number.isFinite(parsedDate) ? parsedDate : Number.NEGATIVE_INFINITY;
};

export const dedupeAndSortTransactions = (transactions: AnalyticsTransactionRow[]) => {
  const dedupedTransactions = new Map<string, AnalyticsTransactionRow>();

  for (const transaction of transactions) {
    dedupedTransactions.set(getTransactionIdentity(transaction), transaction);
  }

  return [...dedupedTransactions.values()].sort((left, right) => {
    const dateDifference =
      getSortableTimestamp(right.dateAndTime) - getSortableTimestamp(left.dateAndTime);

    if (dateDifference !== 0) {
      return dateDifference;
    }

    return getTransactionIdentity(left).localeCompare(getTransactionIdentity(right));
  });
};
